<template>
  <div id="app">
    <router-view></router-view>
<!--    <div style="width: 100%;height: 60px"></div>-->
    <div class="btn-btm">
      <div @click="href(0)"><img class="icon-btm" src="./assets/首页.png"/>首页</div>
      <div @click="href(1)"><img class="icon-btm" src="./assets/饮品.png"/>饮品</div>
      <div @click="href(2)"><img class="icon-btm" src="./assets/订单.png"/>订单</div>
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    href(value){
      if (value == 0 && this.$route.path !== '/location') return this.$router.push('/location')
      if (value == 1 && JSON.parse(localStorage.getItem('shopInfo')) && this.$route.path !== '/shop') {
        this.$router.push('/shop')
      }else if (value == 1 && !JSON.parse(localStorage.getItem('shopInfo'))){
        return this.$message.error('请先选择店铺')
      }
      if(value == 2 && this.$route.path !== '/orderList') return this.$router.push('/orderList')
    }
  }
}
</script>

<style lang="less">
html,body,p{
  padding: 0;
  margin: 0;
}
.btn-btm{
  position: fixed;
  bottom: 0;
  padding: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  //background-color: #E60012;
  //color: white;
  background-color: #F7F7F7;
  div{
    width: 33.33%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div:first-child,div:nth-child(2){
    border-right: 1px solid #F6E9EB;
  }
}

.icon-btm{
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
</style>
